<div class="modal-container">
    <div class="modal-header border-0 justify-content-center">
      <h1 class="modal-title text-center text-primary-color">Mark Complete</h1>
    </div>
    <div class="modal-body">
      <div class="text-center">
        <p class="m-0 text-light-gray primary-text"> Are you sure you want to close this activity?</p>
      </div>
    </div>
    <div class="modal-footer border-0 d-flex flex-column justify-content-center">
      <div class="mb-3 d-flex gap-3">
        <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button popup-button button-info'" (click)="activeModal.close()" [buttonLable]="enumButtonName.CANCEL"></app-button>
        <app-button [buttonType]="'button'"  [button_2]="true" [buttonClass]="'button popup-button button-primary'" (click)="activeModal.close('Confirm')" [buttonLable]="enumButtonName.CONFIRM"></app-button>
      </div>
      <div *ngIf="activityIdsList.length <= 1"  class="mb-3" (click)="activeModal.close('ConfirmandClone')" ><span class="hand text-semi-primary primary-text">Confirm and Clone Activity</span></div>
      <div class="" (click)="activeModal.close('ConfirmandCreateNew')"><span class="hand text-semi-primary primary-text">Confirm and Create New</span></div>
    </div>
  </div>